import React, { useState } from "react";

const OpeningPopup = () => {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl">
        <h2 className="text-xl font-semibold text-[#3E2723]">
          Update!
        </h2>

        <p className="mt-4 text-sm leading-relaxed text-[#3E2723]/80">
          Momenteel blijft de keuken nog even gesloten omdat er extra werken nodig zijn.
          We starten alvast met het serveren van drankjes en kijken ernaar uit
          jullie te verwelkomen 💚
        </p>

        <div className="mt-6 flex justify-end">
          <button
            onClick={() => setIsOpen(false)}
            className="rounded-full bg-[#7ED956] px-4 py-2 text-white hover:bg-[#6ac445]"
          >
            Sluiten
          </button>
        </div>
      </div>
    </div>
  );
};

export default OpeningPopup;